export default function Analytics(section, event) {
    //window.ga('send', 'event', section, event);
    window.dataLayer.push({
        'event': section + ' ' + event
    });
}